/**
 * Whether `useMe` should dispatch GET_USER_DATA.
 * Never call /me without a session token — unauthenticated /me returns 401 and Http
 * redirects to /logout, which loops with LogoutScene → /auth/login.
 */
export default function shouldFetchMe({
  sessionToken,
  ret,
  authCompany,
  subdomain,
  urlCompany,
  needsCompanyRefetch,
  impersonationStale,
}) {
  if (!sessionToken?.hash) {
    return false;
  }

  return (
    !ret.isFetching &&
    (!ret.isError || needsCompanyRefetch || impersonationStale) &&
    (!authCompany ||
      ret.rehydrated ||
      ret.isUninitialized ||
      (subdomain && !urlCompany) ||
      needsCompanyRefetch ||
      impersonationStale)
  );
}
